import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "container-fluid px-5 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Create Business Units")
  ])
], -1)
const _hoisted_3 = { class: "nav toolbar my-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fa-fw" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Business Unit ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "All Business Units")
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "table table-striped" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Parent Unit"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Select parent unit", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'add-businessunits' },
        class: "btn btn-primary mx-auto"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.businessUnitsLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, _toDisplayString(bu.id), 1),
                      _createElementVNode("td", null, [
                        (bu.id === _ctx.updateBuId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "new-bu-name",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatedBusinessUnitName) = $event)),
                                placeholder: "Enter new name"
                              }, null, 512), [
                                [_vModelText, _ctx.updatedBusinessUnitName]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(bu.name), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (bu.id === _ctx.updateBuId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("select", {
                                type: "text",
                                class: "form-control",
                                id: "user-Parents-Name",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatedBusinessUnitParent_ID) = $event))
                              }, [
                                _hoisted_15,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (businessUnit) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: businessUnit.id,
                                    value: businessUnit.id
                                  }, _toDisplayString(businessUnit.name), 9, _hoisted_16))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.updatedBusinessUnitParent_ID]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.getParentName(bu.parent)), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (bu.id !== _ctx.updateBuId && bu.id !== _ctx.deleteBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-primary",
                              type: "button",
                              onClick: ($event: any) => {
                                            _ctx.startUpdateBusinessUnit(bu.id, bu.name);
                                            _ctx.updateBuId = bu.id;
                                        }
                            }, " Update ", 8, _hoisted_18))
                          : _createCommentVNode("", true),
                        (bu.id !== _ctx.updateBuId && bu.id !== _ctx.deleteBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-danger",
                              type: "button",
                              onClick: ($event: any) => (_ctx.startDeleteBusinessUnit(bu.id))
                            }, " Delete ", 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        (bu.id === _ctx.updateBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-primary",
                              type: "button",
                              onClick: ($event: any) => (_ctx.confirmUpdateBusinessUnit(bu.id))
                            }, "Confirm Update", 8, _hoisted_20))
                          : _createCommentVNode("", true),
                        (bu.id === _ctx.deleteBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "btn btn-danger",
                              type: "button",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteBusinessUnit && _ctx.confirmDeleteBusinessUnit(...args)))
                            }, "Confirm Delete"))
                          : _createCommentVNode("", true),
                        (bu.id === _ctx.updateBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              class: "btn btn-secondary",
                              type: "button",
                              onClick: ($event: any) => (_ctx.cancelUpdateBusinessUnit(bu.id))
                            }, "Cancel Update", 8, _hoisted_21))
                          : _createCommentVNode("", true),
                        (bu.id === _ctx.deleteBuId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 5,
                              class: "btn btn-secondary",
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteBusinessUnit && _ctx.cancelDeleteBusinessUnit(...args)))
                            }, "Cancel Delete"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, "Loading business units..."))
      ])
    ])
  ]))
}